
const AboutHeader = () => {
  return (
    <section className="w-full bg-gradient-to-r from-bobo-green to-teedee-blue text-white">
      <div className="w-full py-20 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl lg:text-6xl font-bold mb-8">
            About Bobo & Teedee®
          </h1>
          <p className="text-xl lg:text-2xl max-w-4xl mx-auto opacity-90 leading-relaxed">
            Meet our beloved characters and discover the educational mission behind our Cayman Islands adventures!
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutHeader;
